import { useTheme } from '@emotion/react';
import React from 'react';

import { Alert, Button, Flex, Header, Icon, Text } from '~/components/blocks';

type Props = {
  onBack: () => void;
  error: Error;
};

export const ExclusiveLockError = (props: Props) => {
  const theme = useTheme();

  return (
    <>
      <Flex>
        <Button size="xs" use="white" onClick={props.onBack}>
          <Icon icon="back-line" size="l" />
        </Button>
        <Header>メッセージ作成</Header>
      </Flex>
      <Flex alignItems="center" justifyContent="center">
        <Alert status="error" mt={`calc(${theme.space.xxl} + ${theme.space.s})`}>
          <Text block textAlign="left" size="m" fontWeight="bold">
            {props.error.message}
          </Text>
          <Text block textAlign="left">
            {props.error.name === 'ExclusiveLockError'
              ? '別画面のメッセージ作成を停止後、再度お試しください'
              : 'モーダルを閉じて再度お試しください'}
          </Text>
        </Alert>
      </Flex>
    </>
  );
};
